import React from "react";
import { SUPER_DOG_MARK, SUPER_DOG_LEGEND } from "../utils/superDog";
import HelpMark from "./HelpMark";

/**
 * Explains the 🐕 next to a spread, on the screens where the rule changes a
 * decision: the lineup and the scoreboard.
 *
 * The "?" answers in place, with the scoreboard tour's Super Dog step, rather
 * than linking away. It used to open the whole scoring modal, which made the
 * reader find the one rule they had asked about; the lineup's Scoring cell
 * still opens that.
 *
 * Rendered only when something on the screen actually carries the mark, so the
 * caller decides whether there is anything to explain.
 *
 * This is deliberately not used on the home page. That page sits outside any
 * league and is reachable with no league at all, so it keeps the plain sentence
 * with nothing to tap.
 */
const SuperDogLegend = ({ className = "" }) => (
  <div className={`text-[11px] ${className}`} style={{ color: "var(--color-text-muted)" }}>
    {SUPER_DOG_MARK} {SUPER_DOG_LEGEND}{" "}
    <HelpMark step="scoreboard-superdog" label="How the Super Dog rule works" />
  </div>
);

export default SuperDogLegend;
